import ApiService from "../ApiService";
const {REACT_APP_REST_ENDPOINT} = process.env;

export default class AreeService {

    static getAllAree = () => {
        let url = `${REACT_APP_REST_ENDPOINT}/aree`;
        return ApiService.getRudeRequest(url);
    }

    static getAllSottoaree = () => {
        let url = `${REACT_APP_REST_ENDPOINT}/sottoaree`;
        return ApiService.getRudeRequest(url);
    }

    static createArea = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/aree/create`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }
    static findAreeByIdCorso = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/aree/findByIdCorso`;
            ApiService.postRequest(resolve, reject, url, data)
        });
    }

    static updateArea = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/aree/update`;
            ApiService.putRequest(resolve, reject, url, data)
        });
     }

    static deleteArea = (data) => {
        return new Promise((resolve, reject) => {
            const url = `${REACT_APP_REST_ENDPOINT}/aree/delete`;
            ApiService.delete(resolve, reject, url, data)
        });
     }

    static aggiornaOrdineTree = async (data) => {
        const url = `${REACT_APP_REST_ENDPOINT}/aree/aggiornaOrdineTree`;
        const token = localStorage.getItem("token");
        const headers = {
            "Content-Type": "application/json",
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
        };
        const response = await fetch(url, {
            method: "POST",
            mode: "cors",
            headers,
            body: JSON.stringify(data),
        });
        const status = response.status;
        const bodyText = await response.text();
        if (!response.ok) {
            let parsed = null;
            try { parsed = JSON.parse(bodyText); } catch (_) {}
            const err = new Error(parsed?.error?.message || `HTTP ${status}`);
            err.status = status;
            err.body = bodyText;
            err.parsed = parsed;
            throw err;
        }
        if (!bodyText || !bodyText.trim()) {
            return {};
        }
        try {
            return JSON.parse(bodyText);
        } catch (e) {
            const err = new Error('Risposta non JSON: ' + bodyText.slice(0, 200));
            err.status = status;
            err.body = bodyText;
            throw err;
        }
    }
}